export default "/static/images/claim-popup/0.png"